/**
 * Nombre de cultivo legible: "BITTER_MELON" → "Bitter melon", "EJOTE" → "Ejote".
 * Los nombres que ya vienen legibles (con minúsculas) se dejan tal cual.
 */
export function cropLabel(raw?: string | null): string {
  if (!raw) return '';
  if (/[a-záéíóúñ]/.test(raw)) return raw;
  const s = raw.replace(/_/g, ' ').trim().toLowerCase();
  return s.charAt(0).toUpperCase() + s.slice(1);
}
